/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Help_Weretemporarilyoffline2Inputs */

const en_help_weretemporarilyoffline2 = /** @type {(inputs: Help_Weretemporarilyoffline2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`We're temporarily offline for essential updates. We'll be back online as soon as possible. You can also check back in the next hour. Thank you for your understanding.`)
};

/**
* | output |
* | --- |
* | "We're temporarily offline for essential updates. We'll be back online as soon as possible. You can also check back in the next hour. Thank you for your under..." |
*
* @param {Help_Weretemporarilyoffline2Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const help_weretemporarilyoffline2 = /** @type {((inputs?: Help_Weretemporarilyoffline2Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Help_Weretemporarilyoffline2Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_help_weretemporarilyoffline2(inputs)
});
export { help_weretemporarilyoffline2 as "help_wereTemporarilyOffline" }